import * as client from 'lib/clients/fetchPropertyDetails';
import * as actions from 'store/property/propertyActions';
import * as errorActions from 'store/error/errorActions';
import { getPropertyId } from 'store/property/propertySelectors';
import { getQhUserId } from 'store/user/userSelectors';
import { createAsyncLogic } from 'lib/logic';

export const fetchPropertyLogic = createAsyncLogic({
  type: actions.fetchProperty,
  latest: true,
  async process({ getState, action }, dispatch) {
    dispatch(actions.setLoading(true));
    dispatch(errorActions.clearErrors());
    let propertyId;
    const { payload } = action;
    const state = getState();
    propertyId = getPropertyId(state);
    const qhUserId = getQhUserId(state);
    const { property } = await client.fetchPropertyDetails({ propertyId, qhUserId, ...payload });

    dispatch(actions.fetchPropertySuccess({ property }));
  },
  onError({ parsedError }, dispatch) {
    dispatch(errorActions.apiRequestFailure(parsedError));
  },
  onFinally(context, dispatch) {
    dispatch(actions.setLoading(false));
  },
});
